import Warehouse from "@mui/icons-material/Warehouse";
import { IconButton, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ReturnContext } from "../../contexts/ReturnContext";
import { HtmlTooltip } from "../HtmlTooltip";
import { HeaderBadge } from "./HeaderBadge";
import './index.scss';

export const ReturnBadge: React.FC = () => {
    const navigate = useNavigate();

    const returnContext = useContext(ReturnContext)
    return (
        <HtmlTooltip
            placement="bottom"
            title={
                <>
                    {
                        returnContext.basket.items.length === 0 &&
                        <Typography
                            variant="caption"
                        >
                            Returns Basket is empty
                        </Typography>
                    }
                    {returnContext.basket.items.map((item, i) => {
                        return (
                            <Typography key={i} className="basket-badge-tooltip-item">
                                <span>{item.materialGroup.title}</span>
                                <small>({item.requestedQuantity})</small>
                            </Typography>
                        )
                    })}
                </>
            }
        >
            <IconButton
                aria-label="cart"
                onClick={() => navigate("/return")}
            >
                <HeaderBadge
                    badgeContent={returnContext.basket.items.length}
                    color="secondary"
                    sx={{ color: 'primary.main', opacity: returnContext.basket.items.length > 0 ? 1 : 0.65 }}>
                    <Warehouse />
                </HeaderBadge>
            </IconButton>
        </HtmlTooltip>
    );
};
